import React, { Component } from 'react';
import styled from 'styled-components';

import PageWrapper from './ui/PageWrapper';

const ExhibitionList = styled.div`
  display: grid;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  @media only screen and (min-width: 900px) {
    grid-template-columns: 300px 1fr auto;
  }
  @media only screen and (min-width: 480px){
    padding: 0 50px;
    > div {
      padding-right: 40px;
      > H2 {
        margin-block-start: 20px;
      }
    }
  }
`;

const H2 = styled.h2`
  color: white;
  font-family: Capricorn, sans-serif;
  font-size: 34px;
  font-weight: normal;
  letter-spacing: 0.06em;
`;

const Link = styled.a`
  color: #adadad;
  text-decoration: none;
  &:hover {
    color: #fa0068;
    padding-bottom: 2px;
    border-bottom: 1px solid #fa0068;
  }
`;

class Exhibitions extends Component {
  render() {
    return (
      <PageWrapper>
        <ExhibitionList>
          <div>
            <H2>
              Solo Exhibitions
            </H2>
          </div>
          <div>
            <div>
              <p><b>Anaphoric Fractures <Link href="https://www.tildethurium.com/">(with Tilde Thurium)</Link></b> New York, NY 2022  <i>EV Gallery</i></p>
              <p><b>The stars cut open the sky</b> New York, NY 2021  <i>EV Gallery</i></p>
              <p><b>Expanded Taxonomy</b> Brooklyn, NY 2012  <i>Devotion Gallery</i></p>
              <p><b>Accelerated Uproot & From A Great Height</b> San Francisco, CA 2011  <i>Urban Solutions</i></p>
              <p><b>New Exploration Paper</b> San Francisco, CA 2011  <i>Satellite 66</i></p>
            </div>
          </div>
        </ExhibitionList>
        <ExhibitionList>
          <div>
            <H2>
              Group Exhibitions
            </H2>
          </div>
          <div>
            <div>
              <p><b>METAFLUX: of Present Futures</b> Emeryville, CA 2018  <i>Studio Gabriel Dunne</i></p>
              <p><b>2 BLOCKS of ART</b> San Francisco, CA 2014  <i>Urban Solutions</i></p>
              <p><b>Pop Up</b> Vancouver, BC 2012-2013  <i>Ayden Gallery</i></p>
              <p><b>Wishes and Dreams</b> Brooklyn, NY 2012-2013  <i>inFUSION Gallery @MSKCC</i></p>
              <p><b>ZERO1 Biennial</b> San Jose, CA 2012</p>
              <p><b>Physio/Logical</b> San Francisco, CA 2012  <i>Million Fishes</i></p>
              <p><b>Room 50 - Satellite 66</b> San Francisco, CA 2012  <i>ArtPadSF</i></p>
              <p><b>Galvanize Gala</b> San Francisco, CA 2011  <i>Gray Area Foundation for the Arts</i></p>
              <p><b>Art for Avalos</b> San Francisco, CA 2011  <i>Incline Gallery</i></p>
              <p><b>Alchemy</b> San Francisco, CA 2011  <i>Gray Area Foundation for the Arts</i></p>
            </div>
          </div>
        </ExhibitionList>
      </PageWrapper>
    );
  }
}

export default Exhibitions;



// WEBPACK FOOTER //
// ./src/components/Exhibitions.js